import React from "react";
import {CloseCircleTwoTone} from "@ant-design/icons";

export const PilotLink = ({name, id, object}) => {
    if (!name) return '-';
    if (id === 'DELETE') return name;
    const isLinked = object?.id
    return isLinked ? <a onClick={(e) => e.stopPropagation()} target="_blank" href={`/members/${object.id}`}>{name}</a> : <p><CloseCircleTwoTone twoToneColor='red' /> {name}</p>
  }
  